import { ScreenLoading } from '@/components/loading';
import { ScreenError } from '@/components/screen-error';
import { ScreenUsers } from '@/components/screens/users-screen';
import { useUsers } from '@/hooks/use-users';
import { useScreenProps } from '@/store/theme';

export function UsersPage() {
  const sp = useScreenProps();
  const { data: users, isLoading, isError, error, refetch, isFetching } = useUsers();

  // Erro ANTES do loading: sem isso a tela fica em spinner infinito quando a
  // query falha (isLoading volta a false, mas `users` segue undefined).
  if (isError && !users) {
    return (
      <ScreenError
        error={error}
        onRetry={() => void refetch()}
        retrying={isFetching}
        active="users"
        role="admin"
        title="Usuários"
        subtitle="Aprovação de acesso e papéis do Master Apps"
      />
    );
  }
  if (isLoading || !users) return <ScreenLoading dark={sp.dark} />;

  return (
    <div style={{ height: 'var(--app-vh)', overflow: 'hidden' }}>
      <ScreenUsers {...sp} users={users} />
    </div>
  );
}
